//
//
//
//

export default {
  name: 'BooleanIcon',
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {};
  }
};